// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lrz8fcoaW1Ny6p {
  border-radius: var(--ds-border-radius-200, 8px);
}
.lrz8fcoaW1Ny6p:focus,
.lrz8fcoaW1Ny6p:active,
.lrz8fcoaW1Ny6p.KybfEwGpeuBERA {
  outline-offset: 2px;
  outline: var(--ds-border-focused, #388bff) auto 2px !important;
  outline-offset: 2px !important;
}
.mac .lrz8fcoaW1Ny6p:focus,
.mac .lrz8fcoaW1Ny6p:active,
.mac .lrz8fcoaW1Ny6p.KybfEwGpeuBERA {
  outline-color: -webkit-focus-ring-color !important;
}
.lrz8fcoaW1Ny6p:focus .mac.firefox,
.lrz8fcoaW1Ny6p:active .mac.firefox,
.lrz8fcoaW1Ny6p.KybfEwGpeuBERA .mac.firefox {
  outline-color: AccentColor !important;
}
.lrz8fcoaW1Ny6p.sPpOcA4XceQ73r {
  display: block;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  min-width: 120px;
  min-height: 108px;
  margin: var(--ds-space-050, 4px);
  overflow: hidden;
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
  box-shadow: var(--ds-shadow-raised, 1px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  color: var(--ds-text, #172b4d);
}
.lrz8fcoaW1Ny6p.sPpOcA4XceQ73r a {
  display: block;
  box-sizing: border-box;
  height: 100%;
}
.lrz8fcoaW1Ny6p.sPpOcA4XceQ73r a:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.QzeZzJ7eBZZ8sg {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.Mef9AAKZUnREKu {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 72px;
}
.Mef9AAKZUnREKu svg {
  transform: scale(2);
}
.wlcGwd9HgaOu2r {
  flex: 1;
  background-color: var(--ds-surface, #ffffff);
}
.kqUSfAbwQgTrDj {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin: var(--ds-space-100, 8px);
  overflow: hidden;
  color: var(--ds-text, #172b4d);
  font-weight: var(--ds-font-weight-regular, 400);
  line-height: 20px;
  word-wrap: break-word;
}
`, ""]);
// Exports
export var viewTile = `lrz8fcoaW1Ny6p`;
export var active = `KybfEwGpeuBERA`;
export var grid = `sPpOcA4XceQ73r`;
export var viewDetails = `QzeZzJ7eBZZ8sg`;
export var iconContainer = `Mef9AAKZUnREKu`;
export var viewNameContainer = `wlcGwd9HgaOu2r`;
export var viewName = `kqUSfAbwQgTrDj`;
export default ___CSS_LOADER_EXPORT___;
